module.exports = __webpack_public_path__ + "img/spray-can.c2205837.svg";